export const  calculateActualPrice = (originalPrice, discountPercentage) => {
    const actualPrice = originalPrice * (1 - discountPercentage / 100);
    return Math.round(actualPrice);
}

export const  getEighteenPercent=(a,b)=> {
    let amount =calculateActualPrice(a,b)
    return Math.round(amount * 0.18) 
}